<!-- template v.1 -->
<template>
<div class="col py-3">
            <div class="col-md-12" style="padding:0; text-align:center;margin-bottom:15px">
              <h4 class="card-title" style="text-decoration:underline">Reglas de Marcación </h4>
    
            </div>
             <div class="col-md-12" style="padding:0">
            <!-- Profile Image -->
            <div class="card card-info">
              <div class="card-header">
                <h3 class="card-title">Filtros</h3>
                
              </div>
              <div class="card-body" style="padding-top:0px">
              <div class="col-md-12">
             
                  <div class="col-md-4 form-org">
                 <div class="input-group">
                    <label class="col-form-label"  style="width: 100%;">
                    Nombre
                    </label>
                    <input type="text" class="form-control" maxlength="50" v-model="Nombre" placeholder="Nombre" >
                    
                </div>
                 <div class="input-group" style="margin-top:38px">
                   <button type="submit" 
                   class="btn btn-success" 
                   style="width:100%" 
                   @click="Buscar()" >
                   
                   Buscar</button>
                </div>
               
                   
                
                  </div>
                
                   <div class="col-md-4 form-org">
                    <div class="form-group ">
                  <label class="col-form-label" >
                    Tipos</label
                  >
                  <select class="form-control"    v-model="Tipos">
                    <option value="-1" >Todos </option>
                    <option v-for="item in ListaTipos" :key="item" v-bind:value="item.nCodigo" >{{item.sNombre}}</option>
                    
                  </select>
                </div>
                 <div class="input-group" style="margin-top:38px; display: block;">
                   <router-link to="/nueva-regla">
                   <button type="submit" 
                   class="btn btn-info" 
                   style="width:100%;color:#fff" 
                   >
                   
                   Nuevo</button></router-link>
                </div>
                   </div>
              <div class="col-md-4 form-org">
                  <div class="form-group ">
                  <label class="col-form-label" >
                    Estado</label
                  >
                  <select class="form-control"    v-model="Estado">
                    <option value="-1" >Todos </option>
                    <option v-for="item in ListaEstados" :key="item" v-bind:value="item.nCodigo" >{{item.sNombre}}</option>
                    
                  </select>
                </div>  

                
              </div>
              </div>
             
               
               
               
           
              </div>
              <!-- /.card-body -->
            </div>
           
          

      </div>
      <div class="col-md-12" style=" margin-top: 15px; float:left;padding:0;">
          
          
           <table class="table table-hover table-responsive"  >
                  <thead  class="tabla-asistencia">       
                    <tr >
                      <th >Nombre</th>
                      <th >Aplica a</th>
                      <th >Tipo Regla</th>
                      <th >Valor</th>
                      <th >Estado</th>
                      <th >Opción</th>

                    </tr>
                  </thead>
                  
                   <tbody v-for="(item, index) in ListaReglasPaginador"   v-bind:key="item" v-bind:index="index" >
                    <tr >
                      <td >{{item.sNombre}}</td>
                      <td >{{item.nAplicarA_desc}}</td>
                      <td >{{item.nTipoRegla_desc}} </td>
                      
                      <td >
                          <div v-if="item.nTipoRegla_cod == 2 && item.nValor == 2">
                            No
                          </div>
                          <div v-else-if="item.nTipoRegla_cod == 2 && item.nValor == 1">
                            Sí
                          </div>
                          <div v-else>
                            {{item.nValor}}
                          </div>
                          
                          
                          </td>
                      <td >{{item.sEstadoDesc}}</td>
                      <td >
                        <button type="button" class="btn btn-info btn-table" @click="Clonar(item)">Copiar</button>
                        <button type="button" class="btn btn-info btn-table" @click="Borrar(item)">Borrar</button>

                       
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div style="display: flex;align-items: start;  " >
                    <button  @click="setPage(1)" type="button" style="border-radius: 0px;" class="btn btn-primary" >Primero</button>
                    <nav aria-label="Page navigation example" style="    background: transparent !important;">
                      <ul class="pagination">
                        <li class="page-item" v-for="(pageNumber, index) in totalPages" :key="index" v-show="Math.abs(pageNumber - currentPage) <= 5  || pageNumber == totalPages || pageNumber == 0" >
                            <a class="page-link" style="cursor:pointer" @click="setPage(pageNumber)" :class="{current: currentPage === pageNumber, last: (pageNumber == totalPages && Math.abs(pageNumber - currentPage) > 3), first:(pageNumber == 0 && Math.abs(pageNumber - currentPage) > 3)}">
                                {{ pageNumber }} 
                            </a>
                        </li>
                    </ul>
                    </nav>
                </div>
        </div>
</div>
<ModalPeque v-show="ModalPeque.isBorrarRegla" :modalpeque="ModalPeque">  
    <div class="col-md-12 form-org">
        <div class="form-group" style="text-align:center">
            <label class="col-form-label"> ¿Está seguro borrar la regla? </label>
        </div>
        
        <div class="modal-footer botones-modal">
        <button type="button" class="btn btn-success guardar-modal" @click="BorrarRegla()" >Aceptar</button>
        <button type="button" class="btn btn-danger cancelar-modal" @click="ModalPeque.isBorrarRegla = false"> Cancelar</button>
      </div>
    </div>
   
</ModalPeque> 
   <ModalPeque v-show="ModalPeque.isNuevaRegla" :modalpeque="ModalPeque">  
    <div class="col-md-12 form-org" style="text-align: center;">
        <div class="form-group">
            <label class="col-form-label" > Se proceso la acción con éxito. </label>
        </div>
        
        
    </div>
    </ModalPeque>
    <div class="overlay-wrapper"  v-if="load">
        <div class="overlay" style="flex-direction: column;">
            <i class="spinner-border"></i>
            <div class="text-bold pt-2">Cargando...</div>
        </div>
    </div>
</template>
<script>
export default {
     props: ["content"],

  data: function () {
    return {
      
      Nombre:'',
      ListaTipos:[],
      Tipos:-1,
      ListaEstados:[],
      Estado:1,
      ListaReglas:[],
      ListaReglasPaginador:[],
      itemsPageDefault : 10,
      resultCount: 0,
      currentPage: 0,
      Codigoseleccionado : [],
      load:false,
      ModalPeque : {
        isNuevaRegla : false,
        isBorrarRegla :false,

      },
    

      
    };
  },
  computed: {
        totalPages: function() {
          return Math.ceil(this.resultCount / this.itemsPageDefault)
        },
        
  },
  mounted(){
    this.content.login = false;
    this.content.sistema = true;
    this.ModalPeque.isNuevaRegla = this.$store.state.message;
    this.ModalPeque.titulo = "Mensaje de Confirmación";
    let gestion = this.$store.state.menu;
    this.axios
        .get(gestion + "/ListarParametrosHijos?nCodigo=24", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.ListaTipos = response.data.oListaParametros;
        })
    this.axios
        .get(gestion + "/ListarParametrosHijos?nCodigo=1", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.ListaEstados = response.data.oListaParametros;
        })
  },
  methods: {
    Borrar(item){
    this.ModalPeque.isBorrarRegla=true;
    this.ModalPeque.titulo = 'Anular Horario N°'+ item.nCodigo;
    this.Codigoseleccionado = item.nCodigo;
    
    },
    BorrarRegla(){
      let gestion = this.$store.state.menu;
      var bodyFormData = new FormData();
      bodyFormData.append("nCodigo ",  this.Codigoseleccionado);

      this.axios.post(gestion + "/AnularRegla", bodyFormData, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            "Content-Type": "multipart/form-data",
          }
          })
          .then((response) => {
          const data_res = response.data.satisfactorio;
          this.load=false;
          if (data_res == true) { 
          this.$swal({
          toast: true,
          timer:3000,
          position: 'top',
          showConfirmButton: false,
          title: response.data.message,
          icon: 'success',
          
          });  
          this.ModalPeque.isBorrarRegla=false;
          this.Buscar();
          }
          else{
          this.$swal({
          toast: true,
          timer:3000,
          position: 'top',
          showConfirmButton: false,
          title: response.data.message,
          icon: 'error',
          
          });  
          }
          
        });
    },
    Clonar(item){
        this.$router.push({name: 'clonar-nueva-regla', query: {aplicar: item.nAplicarA_cod, hijo : item.nIdHijo , regla : item.nTipoRegla_cod, valor : item.nValor}});
    },
    setPage: function(pageNumber) {
            this.currentPage = pageNumber;
            if (this.currentPage >= this.totalPages) {
                this.currentPage = this.totalPages  
            }
            var index = (this.currentPage - 1) * this.itemsPageDefault;
            this.ListaReglasPaginador = this.ListaReglas.filter(resp => !resp.disabled ).slice(index, index + this.itemsPageDefault);
    },
    
    
    Buscar(){
    let gestion = this.$store.state.menu;
    this.axios
        .get(gestion + "/ListarReglas?sNombre="+this.Nombre+"&nTipo="+this.Tipos+
        "&nEstado="+this.Estado, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.ListaReglas = response.data.oListaReglas;
          const countUser = this.ListaReglas.filter(resp => !resp.disabled);
          this.resultCount = countUser.length;
          this.currentPage = 0;
          if (this.currentPage >= this.totalPages) {
                this.currentPage = this.totalPages
          }
          var index = this.currentPage * this.itemsPageDefault;      
          this.ListaReglasPaginador = this.ListaReglas.slice(index,index+this.itemsPageDefault);
          
        })

    
    },
     
    
    
   
        

  },
}
</script>
<style scoped>
.btn-table{
    margin: 0 5px;
    font-size: 14px;
}
</style>
